export default "__VITE_ASSET__7a760b5f__"